import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../../hooks/useApi";
import Loader from "../../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../../Input/Textarea";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupActModalProps extends DefaultModalCommonProps {
  popupId?: number;
}

export default function PopupActModal({
  closeEvent,
  confirmEvent,
  popupId,
}: PopupActModalProps) {
  const [reason, setReason] = useState("");

  const [completePopup, setCompletePopup] = useState(false);

  const { response, loading, error } = useApi({
    method: "post",
    url: completePopup ? `popup/${popupId ?? 0}/complete` : ``,
    data: {
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      toast.success("팝업 상태가 변경되었습니다.");
      closeEvent();
      if (confirmEvent) confirmEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "팝업 상태를 변경하는 데에 실패하였습니다.");
    }
  }, [error]);

  return (
    <DefaultModalLayout
      modalTitle="팝업 상태 완료 변경"
      closeEvent={() => closeEvent()}
      confirmEvent={() => setCompletePopup(true)}
      cancelBtnText="취소"
      isSmallModal={true}
      confirmDisabled={reason === ""}
    >
      <ModalLabel>변경 사유</ModalLabel>

      <Textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder="변경 사유 직접 입력 (100글자 이내)"
      />

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
